var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      staticClass: "workspace-module-container",
      attrs: { id: "workspace-result-designs" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.lengthUploadedPhotos))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "result-designs-container" } }, [
        _c("div", { staticClass: "result-lite-grid" }, [
          _c("div", { staticClass: "result-lite-grid-element" }, [
            _c("div", { staticClass: "project-preview" }, [
              _c("img", {
                staticClass: "project-preview-image img-central pointer",
                attrs: { src: _vm.getPhotoDataUrl(Object.keys(_vm.photos)[0]) },
                on: {
                  click: function($event) {
                    _vm.showModal(
                      "modal-result-photo",
                      _vm.getPhotoDataUrl(Object.keys(_vm.photos)[0])
                    )
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wide-result-button top-rounding bot-rounding",
                on: {
                  click: function($event) {
                    return _vm.createPDF()
                  }
                }
              },
              [
                _c("SVGPrint"),
                _vm._v(" "),
                _c("span", { staticClass: "wide-result-button-text" }, [
                  _vm._v("Распечатать ваш заказ")
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result-lite-grid-element" }, [
            _c("div", { attrs: { id: "projects-table-container" } }, [
              _c("table", { staticClass: "result-table" }, [
                _c("thead", [
                  _c("tr", { staticClass: "head-tr" }, [
                    _c("th", { staticClass: "field-number" }, [_vm._v("№")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Эскиз")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Наименование")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Тип продукции")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.productsCost, function(product, index) {
                    return _c("tr", { staticClass: "body-tr row" }, [
                      _c("td", [
                        _c("span", { staticClass: "table-data-central" }, [
                          _vm._v(_vm._s(index + 1))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("img", {
                          staticClass: "result-material-img",
                          attrs: { src: _vm.urlForPhoto(product.src) }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(product.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "table-data" }, [
                          _vm._v(_vm._s(_vm.translateProductType(product.type)))
                        ])
                      ])
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }